export const toastifyStatusSelector = (state) => state.toastify;
